import { Phone } from "@/interfaces/phone";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useUsersPhonesStore = defineStore("usersPhones", () => {
  const usersPhones = ref<Phone[]>([]);

  return {
    usersPhones,

    setUsersPhones(value: Phone[]) {
      usersPhones.value = value;
    },
  };
});
